import * as React from 'react'
import { withNamespaces } from 'react-i18next'
import { withRouter, useHistory } from 'react-router-dom'
import { useState } from 'react'
import { useMutation, useQuery } from '@tanstack/react-query'
import { connect } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next'
import overlayFactory from 'react-bootstrap-table2-overlay'
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator'
import { isFeatureEnabledForActiveModule } from 'src/helpers/module_helper'
import { EMPTY_LIST, INTERNATIONAL_DATE_FORMAT } from 'src/common/constants'
import { toast } from 'react-toastify'
import Spinner from 'react-bootstrap/Spinner'
import FilteringComponent from './components/filtering/FilteringComponent'
import Navigator from '../../../../components/navigator'
import {
    Row,
    Col,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Container,
    Card,
    CardBody,
    Alert
} from 'reactstrap'

import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'react-bootstrap'

import CreateAndEditModal from '../components/CreateAndEditModal'
import DateUtils from 'src/services/utils/DateUtils'
import EntityManagementService from '../../../../api/EntityManagementService'
import CommonService from '../../../../api/CommonService'
import IndustriesService from '../../../../api/IndustriesService'
import DownloadTemplateButton from './components/download-button'
import UploadExcelButton from './components/upload-button'

const Entities = ({ t, lng, Modules, Organization }) => {
    const [ filters, setFilters ] = useState({
        pageIndex: 1,
        pageSize: 25,
        sortField: null,
        sortOrder: null
    })
    const [entities, setEntities] = useState([])
    const [showCreateEntityModal, setShowCreateEntityModal] = useState(false)
    const [selectedEntityToDelete, setSelectedEntityToDelete] = useState(null)
    const [selectedEntityToEdit, setSelectedEntityToEdit] = useState(null)
    const [forceToDelete, setForceToDelete] = useState(false)
    const [moreActionsDropDownOpen, setMoreActionsDropDownOpen] = useState(false)

    const dateUtils = new DateUtils()
    const history = useHistory()

    const entityService = new EntityManagementService()
    const commonService = new CommonService()
    const industriesService = new IndustriesService()

    const toggleMoreActionsDropDown = () => setMoreActionsDropDownOpen(!moreActionsDropDownOpen)

    const {
        active: currentModule
    } = Modules;

    const tableColumns = [
        {
            dataField: 'secondaryId',
            text: t('ID'),
            sort: true,
            key: 0,
            style: {
                width: '80px'
            },
            formatter: (_cellContent, row) => {
                return row.secondary_id
            }
        },
        {
            dataField: 'mandantId',
            text: t('Mandate ID'),
            sort: true,
            key: 1,
            style: {
                width: '120px'
            },
            formatter: (_cellContent, row) => {
                return row.mandant_id
            }
        },
        {
            dataField: 'dcNumber',
            text: t('Debtor/Creditor number'),
            sort: true,
            style: {
                width: '200px'
            },
            key: 2,
            formatter: (_cellContent, row) => {
                return row.dc_number
            }
        },
        {
            dataField: 'title',
            text: t('Full Name'),
            sort: true,
            style: {
                width: '160px'
            },
            key: 3
        },
        {
            dataField: 'shortName',
            text: t('Short Name'),
            sort: true,
            style: {
                width: '160px'
            },
            key: 4,
            formatter: (_cellContent, row) => {
                return row.short_name
            }
        },
        {
            dataField: 'naceCode',
            text: t('Industry'),
            hidden: currentModule !== 'tp',
            sort: true,
            style: {
                width: '160px'
            },
            key: 5,
            formatter: (_cellContent, row) => {
                return row.nace_code?.title
            }
        },
        {
            dataField: 'parent',
            text: t('Parent Entity'),
            sort: true,
            style: {
                width: '160px'
            },
            key: 6,
            formatter: (cellContent) => {
                if(!cellContent) return t('Ultimate Parent');
                
                return cellContent?.short_name
            }
        },
        {
            dataField: 'country',
            text: t('Country'),
            sort: true,
            key: 7,
            style: {
                width: '220px'
            },
            formatter: (_cellContent, row) => {
                return ((row.legal_entity_locations || []).filter((location, index, self) => {
                    return index === self.findIndex((l) => l.country?.id === location.country?.id)
                }).map((location) => t(location.country?.name))).join(', ')
            }
        },
        {
            dataField: 'createdAt',
            text: t('Created on'),
            sort: true,
            key: 8,
            style: {
                width: '160px'
            },
            formatter: (cellContent, row) => {
                return (
                    <span>
                        {dateUtils.convertTimeStampToDate(
                            row.created_at,
                            INTERNATIONAL_DATE_FORMAT
                        )}
                    </span>
                )
            }
        },
        {
            dataField: 'successorAnalyst',
            text: t('Assign By Default'),
            sort: true,
            key: 9,
            formatter: (cellContent, row) => {
                return row.successor_analyst?.full_name
            }
        },
        {
            dataField: 'actions',
            text: t('Action'),
            sort: false,
            key: 10,
            formatter: (cellContent, row) => {
                return (
                    <div className='actions'>
                        {/* <Button
                            onClick={() => setSelectedEntityToEdit(row)}
                            outline
                            color='primary'
                            className='border-0'
                        >
                            <i className='ri-pencil-line font-size-24' />
                        </Button> */}
                        <Button
                            onClick={() =>
                                history.push(
                                    `/admin/entity-management/entities/${row.id}/detail`
                                )
                            }
                            outline
                            color='primary'
                            className='border-0'
                        >
                            <i className='ri-eye-line font-size-24' />
                        </Button>
                        {!row.is_default && (
                            <Button
                                onClick={() => setSelectedEntityToDelete(row.id)}
                                outline
                                color='danger'
                                className='border-0'
                            >
                                <i className='ri-delete-bin-line font-size-24' />
                            </Button>
                        )}
                    </div>
                )
            }
        }
    ]

    const {
        data: industriesList
    } = useQuery({
        queryKey: [
            'entity-management-industries-list-query',
            lng
        ],
        queryFn: async () => {
            return await industriesService.fetchList({
                language: lng !== 'en' ? lng : undefined
            })
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: currentModule === 'tp',
        onError: () => {
            toast(t('An error occurred while fetching industries list.'), {
                type: 'error',
            })
        }
    })

    const {
        isFetching: entitiesAreFetching,
        refetch: refetchEntitiesList,
        data: entitiesList
    } = useQuery({
        queryKey: [
            'entity-management-fetch-all-entities-query', 
            filters,
            Organization.id
        ],
        queryFn: async () => {
            return await entityService.fetchEntitesList({
                ...filters,
                organization: Organization.id
            })
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (_error) => {
            toast(t('An error occurred while fetching entities list.'), {
                type: 'error'
            })
        }
    })

    const totalEntitiesQuery = useQuery({
        queryKey: ['entity-management-fetch-total-entities-query'],
        queryFn: async () => {
            return await entityService.fetchTotalEntities({
                pageIndex: 1,
                pageSize: 1000
            })
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (_error) => {
            toast(t('An error occurred while fetching entities list.'), {
                type: 'error'
            })
        }
    })

    const analystsListQuery = useQuery({
        queryKey: ['entity-management-fetch-admins-query'],
        queryFn: async () => {
            return await commonService.fetchAnalystAndAdminAnalystList()
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (_error) => {
            toast(t('An error occurred while fetching analysts list.'), {
                type: 'error'
            })
        }
    })

    const { isFetching: countriesAreFetching, data: countriesList } = useQuery({
        queryKey: ['entity-management-fetch-countries-query'],
        queryFn: async () => {
            return await commonService.fetchCountriesList()
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (_error) => {
            toast(t('An error occurred while fetching countries list.'), {
                type: 'error'
            })
        }
    })

    const { isLoading: createEntityIsLoading, mutate: mutateEntityCreation } =
        useMutation({
            mutationFn: async (payload) => {
                return await entityService.create(payload)
            },
            onSuccess: () => {
                setShowCreateEntityModal(false)
                refetchEntitiesList()
                totalEntitiesQuery.refetch()

                toast(t('Entity created successfully.'), {
                    type: 'success'
                })
            },
            onError: (error) => {
                if (error?.response?.data?.error) {
                    toast(t(error?.response?.data?.error), {
                        type: 'error'
                    })
                } else {
                    toast(t('Failed to create entity.'), {
                        type: 'error'
                    })
                }
            }
        })

    const { isLoading: editEntityIsLoading, mutate: mutateEntityEdit } =
        useMutation({
            mutationFn: async (payload) => {
                return await entityService.edit(selectedEntityToEdit.id, payload)
            },
            onSuccess: () => {
                setSelectedEntityToEdit(null)
                refetchEntitiesList()
                totalEntitiesQuery.refetch()

                toast(t('Entity updated successfully.'), {
                    type: 'success'
                })
            },
            onError: (error) => {
                if (error?.response?.data?.error) {
                    toast(t(error?.response?.data?.error), {
                        type: 'error'
                    })
                } else {
                    toast(t('Failed to edit entity.'), {
                        type: 'error'
                    })
                }
            }
        })

    const { isLoading: deleteEntityIsLoading, mutate: mutateEntityDelete } =
        useMutation({
            mutationFn: async (entityId) => {
                return (await forceToDelete)
                    ? entityService.forceDelete(entityId)
                    : entityService.delete(entityId)
            },
            onSuccess: () => {
                setSelectedEntityToDelete(null)
                refetchEntitiesList()

                toast(t('Entity deleted successfully.'), {
                    type: 'success'
                })
            },
            onError: (error) => {
                const errorMessage = error.response?.data?.error
                if (
                    errorMessage.toLowerCase() ===
                    'legal entity has child. please first remove them'
                ) {
                    setForceToDelete(true)
                } else {
                    toast(t('Failed to delete entity.'), {
                        type: 'error'
                    })
                }
            }
        })

    const analystMemoList = React.useMemo(() => {
        return (analystsListQuery.data || []).map((item) => {
            return {
                label: `${item.first_name} ${item.last_name}`,
                value: item.id
            }
        })
    }, [analystsListQuery.data])

    const countriesMemoList = React.useMemo(() => {
        return (countriesList || []).map((item) => {
            return {
                label: t(item.name),
                value: item.id
            }
        })
    }, [countriesList, t])

    const totalEntitiesMemoList = React.useMemo(() => {
        return (totalEntitiesQuery.data?.legalEntities || []).map((item) => {
            return {
                label: item.title,
                value: item.id
            }
        })
    }, [totalEntitiesQuery.data])

    const handleFilterChange = React.useCallback((newFilters) => {
        setFilters({
            ...filters,
            ...newFilters,
            pageIndex: 1
        })
    }, [])

    React.useEffect(() => {
        if (!selectedEntityToDelete && forceToDelete) {
            setForceToDelete(false)
        }
    }, [selectedEntityToDelete])

    React.useEffect(() => {
        if(entitiesList?.legalEntities){
            const result = entitiesList.legalEntities.map((legal) => {
                if(legal.nace_code){
                    const translatedIndustry = (industriesList || []).find((industry) => {
                        return industry.id === legal.nace_code.id
                    })
    
    
                    return {
                        ...legal,
                        nace_code: {
                            id: legal.nace_code.id,
                            title: translatedIndustry ? 
                                `${translatedIndustry.class} - ${translatedIndustry.title}` :
                                `${legal.nace_code.product_group} - ${legal.nace_code.activity}` 
                        } 
                    }
                }
                
                return {...legal}
            })


            setEntities(result)
        }
    }, [
        entitiesList?.legalEntities,
        industriesList
    ])

    const NoDataIndication = () => {
        if (!entitiesAreFetching && !parseInt(entitiesList?.itemsCount)) {
            return (
                <div className='alert m-0' role='alert'>
                    <p
                        style={{
                            textAlign: 'center',
                            marginBottom: 0
                        }}
                    >
                        {t(EMPTY_LIST)}
                    </p>
                </div>
            )
        }

        return <React.Fragment />
    }

    const handleTableChange = (type, data) => {
        switch (type) {
            case 'pagination': {
                const { page, sizePerPage } = data

                setFilters({
                    ...filters,
                    pageIndex: page,
                    pageSize: sizePerPage
                })
                break
            }
            case 'sort': {
                const { sortField, sortOrder } = data

                setFilters({
                    ...filters,
                    sortField,
                    sortOrder
                })
                break
            }
            default:
                return false
        }
    }

    const renderModals = () => {
        if (
            entitiesAreFetching ||
            countriesAreFetching ||
            analystsListQuery.isFetching ||
            totalEntitiesQuery.isFetching
        ) {
            return null
        }

        return (
            <React.Fragment>
                <Modal
                    size='lg'
                    scrollable
                    isOpen={!!selectedEntityToDelete}
                    backdrop='static'
                >
                    <ModalHeader toggle={() => setSelectedEntityToDelete(null)}>
                        {t('Delete Entity')}
                    </ModalHeader>

                    <ModalBody>
                        <p>
                            {t('Are you sure you want to delete this entity?')}
                        </p>
                        {forceToDelete && (
                            <div className='alert alert-danger' role='alert'>
                                <p className='mb-0'>
                                    {t(
                                        'This entity has child entities so all children will be removed as well. to continue please click the confirm button?'
                                    )}
                                </p>
                            </div>
                        )}

                        <ModalFooter>
                            <Button
                                disabled={deleteEntityIsLoading}
                                color='primary'
                                outline
                                className='waves-effect waves-light'
                                type='button'
                                onClick={() => {
                                    setSelectedEntityToDelete(null)
                                }}
                            >
                                {t('Cancel')}
                            </Button>

                            <Button
                                disabled={deleteEntityIsLoading}
                                color='danger'
                                type='button'
                                className='waves-effect waves-light'
                                onClick={() =>
                                    mutateEntityDelete(selectedEntityToDelete)
                                }
                            >
                                {deleteEntityIsLoading && (
                                    <Spinner
                                        animation='border'
                                        variant='white'
                                        size='sm'
                                        className='me-1'
                                    />
                                )}
                                {forceToDelete ? (
                                    <React.Fragment>
                                        {t('Confirm')}
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        {t('Delete')}
                                    </React.Fragment>
                                )}
                            </Button>
                        </ModalFooter>
                    </ModalBody>
                </Modal>

                <CreateAndEditModal
                    show={showCreateEntityModal || selectedEntityToEdit}
                    toggle={() => {
                        setShowCreateEntityModal(false)
                        setSelectedEntityToEdit(null)
                    }}
                    onSubmit={(values, action) => {
                        if (action === 'edit') {
                            mutateEntityEdit(values)
                        } else {
                            mutateEntityCreation(values)
                        }
                    }}
                    analystMemoList={analystMemoList}
                    countriesMemoList={countriesMemoList}
                    parentEntitiesMemoList={totalEntitiesMemoList}
                    entity={selectedEntityToEdit}
                    submitInProgress={
                        createEntityIsLoading || editEntityIsLoading
                    }
                />
            </React.Fragment>
        )
    }

    if (!isFeatureEnabledForActiveModule('entity_management')) {
        return (
            <div className='page-content'>
                <Alert color='warning'>
                    {t('Please upgrade your plan to access this feature')}.
                </Alert>
            </div>
        )
    }

    return (
        <div className='page-content'>
            {renderModals()}

            <Container fluid>
                <Row>
                    <Col lg='12' className='mb-4'>
                        <Navigator
                            backButtonOptions={(props) => {
                                return {
                                    ...props,
                                    enable: true
                                }
                            }}
                            breadCrumbs={[
                                {
                                    title: 'Entity Management',
                                    link: '/admin/entity-management/entities'
                                },
                                {
                                    title: 'Entities',
                                    link: `#`
                                }
                            ]}
                        />
                    </Col>

                    <Col lg='12'>
                        <Card>
                            <CardBody>
                                {tableColumns && tableColumns.length > 0 && (
                                    <PaginationProvider
                                        pagination={paginationFactory({
                                            custom: true,
                                            page: filters.pageIndex,
                                            sizePerPage: filters.pageSize,
                                            totalSize:
                                                entitiesList?.itemsCount || 0,
                                            withFirstAndLast: false,
                                            alwaysShowAllBtns: true,
                                            prePageText: (
                                                <span>
                                                    <i className='ri-arrow-left-s-line' />{' '}
                                                    {t('Back')}
                                                </span>
                                            ),
                                            nextPageText: (
                                                <span>
                                                    {t('Next')}{' '}
                                                    <i className='ri-arrow-right-s-line' />
                                                </span>
                                            ),
                                            prePageTitle: t('Pre page'),
                                            firstPageTitle: t('Next page'),
                                            showTotal: true,
                                            hideSizePerPage: false,
                                            sizePerPageList: [
                                                {
                                                    text: '25',
                                                    value: 25
                                                },
                                                {
                                                    text: '50',
                                                    value: 50
                                                }
                                            ]
                                        })}
                                    >
                                        {({
                                            paginationProps,
                                            paginationTableProps
                                        }) => (
                                            <React.Fragment>
                                                <Row className='mb-5'>
                                                    <Col sm='12'>
                                                        <div className='d-flex justify-content-end align-items-center'>
                                                            <div className='d-flex'>
                                                                <FilteringComponent 
                                                                    analystsListQuery={analystsListQuery}
                                                                    totalEntitiesQuery={totalEntitiesQuery}
                                                                    onChange={handleFilterChange}
                                                                />
                                                            </div>

                                                            <div className='d-flex'>
                                                                <Dropdown 
                                                                    isOpen={moreActionsDropDownOpen} 
                                                                    toggle={toggleMoreActionsDropDown}
                                                                >
                                                                    <DropdownToggle 
                                                                        caret 
                                                                        variant="outline-secondary"
                                                                        outline
                                                                    >
                                                                        {t('Actions')}
                                                                    </DropdownToggle>
                                                                    <DropdownMenu
                                                                        className='dropdown-menu-end'
                                                                    >
                                                                        <DropdownItem
                                                                            onClick={() => {
                                                                                setShowCreateEntityModal(
                                                                                    true
                                                                                )
                                                                            }}
                                                                        >
                                                                            <i className='ri-add-line align-middle me-1' />
                                                                            {t('Add Entity')}
                                                                        </DropdownItem>

                                                                        <DropdownItem
                                                                            onClick={(e) => {
                                                                                e.preventDefault()
                                                                                e.stopPropagation()
                                                                            }}
                                                                        >
                                                                            <DownloadTemplateButton />
                                                                        </DropdownItem>
                                                                        <DropdownItem>
                                                                            <UploadExcelButton 
                                                                                onSuccess={() => {
                                                                                    refetchEntitiesList()
                                                                                }}
                                                                            />
                                                                        </DropdownItem>
                                                                    </DropdownMenu>
                                                                </Dropdown>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm='12'>
                                                        <BootstrapTable
                                                            remote={{
                                                                pagination: true,
                                                                filter: false,
                                                                sort: true,
                                                                cellEdit: false,
                                                                search: false
                                                            }}
                                                            loading={
                                                                entitiesAreFetching
                                                            }
                                                            overlay={overlayFactory(
                                                                {
                                                                    spinner: (
                                                                        <Spinner
                                                                            animation='border'
                                                                            variant='primary'
                                                                            size='md'
                                                                        />
                                                                    ),
                                                                    text: 'Loading...'
                                                                }
                                                            )}
                                                            onTableChange={
                                                                handleTableChange
                                                            }
                                                            defaultSorted={[]}
                                                            keyField='id'
                                                            responsive
                                                            bordered={false}
                                                            data={entities}
                                                            striped
                                                            columns={
                                                                tableColumns
                                                            }
                                                            wrapperClasses='table-responsive'
                                                            classes='table tpdd-table'
                                                            headerWrapperClasses='thead-light'
                                                            style={{
                                                                overflowX:
                                                                    'auto'
                                                            }}
                                                            noDataIndication={() => (
                                                                <NoDataIndication />
                                                            )}
                                                            {...paginationTableProps}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col sm='12' md='6'>
                                                        <div className='tpdd-pagination-style-1 justify-content-end'>
                                                            <div 
                                                                className={`${parseInt(entitiesList?.itemsCount) < parseInt(entitiesList?.pageSize) ? 'd-none' : ''}`}
                                                            >
                                                                <PaginationListStandalone
                                                                    {...paginationProps}
                                                                />
                                                            </div>

                                                            <SizePerPageDropdownStandalone
                                                                {...paginationProps}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </React.Fragment>
                                        )}
                                    </PaginationProvider>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

const mapToState = (state) => {
    const { Organization, Modules } = state

    return {
        Organization,
        Modules
    }
}

export default withNamespaces()(withRouter(connect(mapToState, {})(Entities)))
